import React from "react";

/** Фиксированная высота рабочей области — без прокрутки всей страницы. */
export function WorkspacePanel({ children, testId = "workspace-panel", className = "" }) {
  return (
    <div
      data-testid={testId}
      className={`workspace-panel d-flex flex-column ${className}`.trim()}
    >
      {children}
    </div>
  );
}

/** Верхняя часть (заголовок, фильтры) — не прокручивается. */
export function WorkspaceToolbar({ children, className = "" }) {
  return (
    <div className={`workspace-toolbar flex-shrink-0 ${className}`.trim()}>
      {children}
    </div>
  );
}

/** Основной контент — дочерние блоки сами задают скролл (таблица и т.д.). */
export function WorkspaceBody({ children, className = "", testId = "workspace-body" }) {
  return (
    <div
      data-testid={testId}
      className={`workspace-body ${className}`.trim()}
    >
      {children}
    </div>
  );
}

/** Прокручиваемая область (если весь блок контента скроллится целиком). */
export function WorkspaceScroll({ children, className = "", testId = "workspace-scroll" }) {
  return (
    <div
      data-testid={testId}
      className={`workspace-scroll ${className}`.trim()}
    >
      {children}
    </div>
  );
}

/** Прокручиваемая таблица / список внутри рабочей области. */
export function WorkspaceTableScroll({ children, className = "", testId = "workspace-table-scroll" }) {
  return (
    <div
      data-testid={testId}
      className={`workspace-table-scroll ${className}`.trim()}
    >
      {children}
    </div>
  );
}
